export class Configuration {
  id: number;
  customerId: number;
  configName: string;
  /*corpOid: string;*/
  createdBy: string;
  createdDate: string;
  modifiedBy: string;
  modifiedDate: string;
  isDefault: string;
  isGlobal: boolean;
  configType: string;
  productsNeeded: string[];
  // packageType: string;
  userManagementOkta: string;
  userManagementKeycloak: string;
  userManagementLegacy: string;
  sharedComponentsLauncher: string;
  sharedComponentsContextSharing: string;
  subdomainName: string;
  configNotes: string;
  isActive: boolean;
  guid: string;


  public constructor(init?: Partial<Configuration>) {
    Object.assign(this, init);
  }
}
